import React, {
    CSSProperties, forwardRef,
    memo,
    useCallback,
    useEffect, useImperativeHandle, useLayoutEffect, useMemo,
    useRef,
    useState,
} from "react";
import "./VideoNotes.scss";
import {ConfigProvider, message, Modal} from "antd";
import VideoHeader from "./VideoHeader";
import VideoContent from "./VideoContent";
import { saveElementVideoNotesAsJSON } from "../../data/json";
import { VideoNotesType } from "../../types";
import { isEmbeddableElement, isImageElement } from "../../element/typeChecks";
import VideoLocalContent from "./VideoLocalContent";
import {
    base64ToBlob,
    getLocalFilePath,
    isAudioFileElement,
    isFileVideoElement,
    isInPageTag
} from "../../../../../src/utils";
import {postMessage, recvMessage, unSubscribe} from "../../../../../src/common/event";
import {
    EVENT_ISFULL_SCREEN,
    EVENT_REFRESH_VIDEO_NOTE,
    EVENT_VIDEO_ON_SLIDER_RIGHT,
    FROM_DIALOG
} from "../../../../../src/Const";
import {t} from "i18next";
import Global from "../../../../../src/global";
import {createBreadcrumb} from "../../../../../src/Utility";
import {dbGetHighlight, getCardById} from "../../../../../model";
import global from "../../../../../src/global";
import {useAtom} from "jotai";
import {atomCardItemPointerEvent} from "../../../../../src/views/Home/HomeIndex";
import {ipcSend} from "../../../../../src/common/ipc";

export interface VideoNotesProps {
  videoNotes: VideoNotesType;
  onVideoNotes: (element: any) => void;
    from?:any;
    zIndex?:any;
  setToast: (
    toast: {
      message: string;
      closable?: boolean;
      duration?: number;
    } | null,
  ) => void;
}

// export const atomIsFullScreen = atom(false);

const VideoNotes = forwardRef(
  ({ videoNotes, onVideoNotes, setToast,from,zIndex }: VideoNotesProps,ref) => {
      useImperativeHandle(ref,()=>({
          getIsPin:getIsPin,
          getData:getData,
          showOrHidden:showOrHidden
      }))
    const videoNotesRef = useRef<HTMLDivElement>(null);
    const videoContentRef = useRef<any>(null);
    const draggleRef = useRef<any>(null);
    const [isPin,setIsPin] = useState(false);

    // const { visibility, type, element } = useMemo(() => {
    //   return { ...videoNotes };
    // }, [videoNotes]);

      const { visibility, type, element } = {...videoNotes};

    const [isFullScreen,setIsFullScreen] = useState(false);

      const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);

    const [modalStyle, setMdalStyle] = useState<CSSProperties>({
      width: "70%",
      height: "70%",
        paddingBottom:'0px'
    });

    const videoHeaderRef = useRef(null);

      //拖拽
      const mIsDragging = useRef<any>(false);
      const offset = useRef<any>({x:0,y:0});

      const nWidth = isAudioFileElement(videoNotes.element)?750: document.body.clientWidth*0.8;
      const nHeight = isAudioFileElement(videoNotes.element)?document.body.clientHeight*0.8:document.body.clientHeight*0.85;
      const mResizing = useRef(null);
      const [x, setX] = useState((document.body.clientWidth-nWidth)*0.5); // div 的左上角 x 坐标
      const [y, setY] = useState((document.body.clientHeight - nHeight)*0.5); // div 的左上角 y 坐标
      // const [resizing, setResizing] = useState(null); // 当前正在拖拽的角
      const [isVisible,setIsVisible] = useState(true);

      const initialMousePos = useRef<any>({ x: 0, y: 0});
      const [dialogSize,setDialogSize] = useState<any>({width:nWidth,height:nHeight});
      const [pointerEvents,setPointerEvents] = useState('all');
      const [hasMaskLayer,setHasMaskLayer] = useState(window.getDialogPinCount() == 0);

    const getIsPin = ()=>{
        return videoHeaderRef.current?.getIsPin();
    }
    const getData = ()=>{
        return videoNotes;
    }

      /**
       * 显示或隐藏
       */
      function showOrHidden(){
          if (global.g_isHiddenAllFloatWin){
              setIsVisible(false)
          }else{
              setIsVisible(true)
          }
      }

    const onClose = (isCloseDialog = false) => {
        global.g_showDialogs['dialogVideoNotes'] = false;
      videoContentRef.current?.pauseVideo();
      if (isCloseDialog){
          window.closeVideoNotes(videoNotes);
      }
      if (document.fullscreenElement) {
        document.exitFullscreen();
        onVideoNotes({ ...videoNotes, type: "model", visibility: false });
        setMdalStyle({
          width: "70%",
          height: "70%",
        });
        // return;
      }
      // onVideoNotes({ ...videoNotes, visibility: false });
        window.closeVideoNotes(videoNotes);
    };
    const onCopy = async () => {
      const text = videoContentRef.current!.getCurrentElementVideoNotes();
      await navigator.clipboard.writeText(text);
      message.info(t('Notes copied to clipboard'))
    };
    const onExport = () => {
      const exportValues =
        videoContentRef.current!.exportCurrentElementVideoNotes();
      saveElementVideoNotesAsJSON(exportValues);
    };

      /**
       * 直接WEB端的全屏...不通过客户端
       */
      const onFullScreenByWeb = (bIsFullScreen: boolean) => {
          if (bIsFullScreen) {
              var ele = document.body;
              if (ele.requestFullscreen) {
                  ele.requestFullscreen();
              } else if (ele.mozRequestFullScreen) {
                  ele.mozRequestFullScreen();
              } else if (ele.webkitRequestFullscreen) {
                  ele.webkitRequestFullscreen();
              } else if (ele.msRequestFullscreen) {
                  ele.msRequestFullscreen();
              }
          } else {
              if (document.exitFullScreen) {
                  document.exitFullScreen();
              } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
              } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
              } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
              }
          }
      }


      const onFullScreen = () => {
      const videoNotesElement = videoNotesRef.current;

      if (!videoNotesElement) {
        return;
      }

      // // 检查当前页面是否处于全屏模式
      // if (document.fullscreenElement) {
      //     setIsFullScreen(false);
      //   document.exitFullscreen();
      //   return;
      // }

      document.documentElement.requestFullscreen();
      // onFullScreenByWeb(true);
      setIsFullScreen(true);
      onVideoNotes({ ...videoNotes, type: "fullScreen" });
      setMdalStyle({
        width: "100vw",
        height: "100vh",
        top: "0",
      });
    };
    const exitFullscreen = useCallback(() => {
      if (!document.fullscreenElement) {
          setIsFullScreen(false)
        onVideoNotes({ ...videoNotes, type: "model" });
        setMdalStyle({
          width: "70%",
          height: "70%",
        });
      }
    }, [onVideoNotes, videoNotes]);

      const exitFullscreenForPerson = () => {
          setIsFullScreen(false);
          document.exitFullscreen();
      };

    useEffect(()=>{
        setTimeout(()=>{
            if (type == 'fullScreen'){
                onFullScreen();
            }
        },200)
    },[type])

      useEffect(() => {
          console.log(x);
      }, [videoNotes]);


      useEffect(() => {
          if (visibility){
              setTimeout(()=>{
                  videoContentRef.current?.refreshVideoNotes();
              },100)
          }

      }, [visibility]);

      useEffect(()=>{
          setHasMaskLayer(window.getDialogPinCount() == 0);

          if (Global.g_isCtrlPressed){
              setIsPin(true);
              setHasMaskLayer(false);
          }

          document.body.addEventListener('mousemove',handleMouseMove);
          document.body.addEventListener('mouseup',handleMouseUp);

          recvMessage(EVENT_ISFULL_SCREEN,(msg,data)=>{
              if (!data.data.isFullScreen){
                  exitFullscreenForPerson();
              }
          })

          return ()=>{
              document.body.removeEventListener('mousemove',handleMouseMove);
              document.body.removeEventListener('mouseup',handleMouseUp);
              unSubscribe(EVENT_ISFULL_SCREEN);
              if (isInPageTag()){
                  window.globalRefreshList('refresh_tableview_single_data_',videoNotes.element?.customData?.generationData?.id)
              }
          }
      },[])

      useEffect(() => {
          if (isPin){
              if (global.g_isHiddenAllFloatWin){
                  //有隐藏的
                  window.visibleAllFloatWin();
              }
          }
      }, [isPin]);

      useEffect(()=>{
          window.exitFullScreen = ()=>{
              onClose(true);
          }

          return ()=>{
              delete window.exitFullScreen;
          }
      })


      const handleMouseDown = (corner) => (e) => {
          mResizing.current = (corner);
          initialMousePos.current = ({ x: e.clientX, y: e.clientY });
          e.preventDefault();
          e.stopPropagation();
      };

      const handleMouseMove = (e) => {
          if (mResizing.current){
              e.stopPropagation();
              setPointerEvents('none');
              const rect = draggleRef.current.getBoundingClientRect();
              const deltaX = e.clientX - initialMousePos.current.x;
              const deltaY = e.clientY - initialMousePos.current.y;
              let nWidth = 0,nHeight =0;

              switch (mResizing.current) {
                  case 'top-left':
                      nWidth = (Math.max(rect.width - deltaX, 50));
                      nHeight = (Math.max(rect.height - deltaY, 50));
                      setX(rect.left + deltaX);
                      setY(rect.top + deltaY);
                      break;
                  case 'top-right':
                      nWidth = (Math.max(rect.width + deltaX, 50));
                      nHeight = (Math.max(rect.height - deltaY, 50));
                      setY(rect.top + deltaY);
                      break;
                  case 'bottom-left':
                      nWidth = (Math.max(rect.width - deltaX, 50));
                      nHeight = (Math.max(rect.height + deltaY, 50));
                      setX(rect.left + deltaX);
                      break;
                  case 'bottom-right':
                      nWidth = (Math.max(rect.width + deltaX, 50));
                      nHeight = (Math.max(rect.height + deltaY, 50));
                      break;
                  case "left":
                      nWidth = (Math.max(rect.width - deltaX, 50));
                      nHeight = rect.height;
                      setX(rect.left + deltaX);
                      break;
                  case "top":
                      nWidth = rect.width;
                      nHeight = (Math.max(rect.height - deltaY, 50));
                      setY(rect.top + deltaY);
                      break;
                  case "right":
                      nWidth = (Math.max(rect.width + deltaX, 50));
                      nHeight = rect.height;
                      break;
                  case "bottom":
                      nWidth = rect.width;
                      nHeight = (Math.max(rect.height + deltaY, 50));
                      console.log(nHeight+'deltaY:'+deltaY+'   rectHeight:'+rect.height);
                      break;
                  default:
                      break;
              }
              if (nWidth < 700){
                  nWidth = 700;
              }
              if (nHeight < 600){
                  nHeight = 600;
              }
              setDialogSize({
                  width: nWidth,
                  height: nHeight,
                  maxHeight: '100vh'
              })

              initialMousePos.current = ({ x: e.clientX, y: e.clientY });
          }

          if (mIsDragging.current) {
              setX(e.clientX - offset.current.x);
              setY(e.clientY - offset.current.y);
          }

      };

      const handleMouseUp = () => {
          mResizing.current = (null);
          setPointerEvents('all');
      };


    return (
      <div
        ref={videoNotesRef}
        className="video-notes-wrapper"
        onMouseDown={(e) => e.stopPropagation()}
      >
          {/*真是服了，弹窗也一会这种背景，一会那种背景*/}
          <ConfigProvider
              theme={{
                  components: {
                      Modal: {
                          contentBg:'var(--dialog-dialog-background-color-2c)',
                          colorText:'var(--text-color)',
                          boxShadow:'var(--box-shadow-popover)'
                      },
                  }
              }}>

              <Modal
                  keyboard = {!isPin}
                  rootClassName={'videonotes-dialog-'+videoNotes.id}
                  zIndex={zIndex}
                  className="video-notes-model-wrapper"
                  classNames={{
                      content: !isFullScreen ? "" : "video-full-screen-content",
                  }}
                  mask={hasMaskLayer}
                  centered={true}
                  getContainer={false}
                  closable={false}
                  width={type === "model" ? (isAudioFileElement(videoNotes.element)?`${dialogSize.width}px`:dialogSize.width+'px') : "100%"}
                  style={{
                      margin:'0px',
                      left:isFullScreen ?'0px':x+'px',
                      top:isFullScreen ?'0px':y+'px',
                      minWidth:isFullScreen ?'100vw':(dialogSize.width+'px'),
                      width:isFullScreen ?'100vw':(dialogSize.width+'px'),
                      height:isFullScreen ?'100vh':((dialogSize.height)+'px'),
                      position:'fixed',
                      display:isVisible?'':'none',
                  }}
                  destroyOnClose={true}
                  styles={{
                      wrapper: {
                          overflow: "hidden",
                          borderRadius: 0,
                          pointerEvents:isPin?'none':'all',
                      },
                      content: {
                          width: isFullScreen?'100vw':(dialogSize.width)+'px',
                          height: isFullScreen?'100vh':(dialogSize.height) + "px",
                          borderRadius: 10,
                          padding:'20px 24px 10px 24px'
                      }
                  }}
                  title={
                      <VideoHeader
                          ref={videoHeaderRef}
                          isFullScreen={isFullScreen}
                          onCopy={onCopy}

                          onCapture={()=>{
                              videoContentRef.current?.onGetCapture().then(async (res) => {
                                  if (res == 'data:,'){
                                      message.error(t("PleasePlayBefore"));
                                      return;
                                  }

                                  const blob = base64ToBlob(res, 'image/png');
                                  const item = new ClipboardItem({'image/png': blob})
                                  await navigator.clipboard.write([item]);
                                  window.showMessageBox(t("ScreenshotCopiedToClipboard"), t("YouCanDownload"), t("Download"), t("OK"), async () => {
                                      const library = await getCardById(videoNotes.element.customData?.generationData?.id || videoNotes.element.id);
                                      ipcSend('saveFile', {
                                          streamType: 'image',
                                          stream: res.split(',')[1],
                                          filters: '[{ name: \'Images\', extensions: [\'png\'] }]',
                                          fileName: library?.name + '.png'
                                      });
                                  },null)
                              })
                          }}
                          onExport={onExport}
                          onFullScreen={onFullScreen}
                          onExitFullScreen={exitFullscreenForPerson}
                          onClose={onClose}
                          onSetPin={(isPin:any)=>{
                              setIsPin(isPin);
                              setTimeout(()=>{
                                  const nPinCount = window.getDialogPinCount();
                                  if (nPinCount > 0){
                                      setHasMaskLayer(false);
                                  }else{
                                      setHasMaskLayer(!isPin);
                                  }
                              },100);
                          }}
                          onSlider={async ()=>{
                              if (window.location.href.includes("/draw") || window.location.href.includes("/defaultProject")){
                                  let library = await dbGetHighlight(element.id);
                                  if (library) {
                                      postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,{videoNotes: {...videoNotes,type:'fullscreen'},isFullScreen:true,breadcrumb:createBreadcrumb('highlight',library?.name)});
                                  }else {
                                      library = await getCardById(element.customData?.generationData?.id || element.id);
                                      if (library) {
                                          postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,{videoNotes: {...videoNotes,type:'fullscreen'},isFullScreen:true,breadcrumb:createBreadcrumb('highlight',library?.name)});
                                      }
                                  }
                              }else {
                                  let library = await dbGetHighlight(element.id);
                                  if (library) {
                                      window.openRightSlider(library,library.type);
                                  }else {
                                      library = await getCardById(element.customData?.generationData?.id || element.id);
                                      if (library) {
                                          window.openRightSlider(library,library.type);
                                      }
                                  }
                              }

                              onClose();
                          }}
                          onImportHighlight={(file, content)=>{
                              videoContentRef.current?.onImportHighlights(file,content);
                          }}
                          onImportTranscript={(file,content)=>{

                          }}
                          onSearch={(szSearchKey)=>{
                              szSearchKey = szSearchKey.toLowerCase();
                              videoContentRef.current?.onSearch(szSearchKey);
                          }}
                          element={videoNotes.element}
                          onUpdateMediaPath={(szNewFilePath)=>{
                              const newVideoNotes = {...videoNotes};
                              newVideoNotes.element.customData.generationData.fileName = szNewFilePath;
                              onVideoNotes(newVideoNotes)
                          }}
                          type={type}
                          from={from}
                      />
                  }
                  afterOpenChange={(e)=>{
                      Global.g_showDialogs['dialogVideoNotes'] = e;
                  }}
                  open={videoNotes.visibility}
                  onCancel={onClose}
                  footer={false}
                  modalRender={(modal) => (
                      // <Draggable
                      //     disabled={false}
                      //     // bounds={bounds}
                      //     nodeRef={draggleRef}
                      //     onMouseDown={(event)=>{
                      //         event.stopPropagation();
                      //     }}
                      //     onStart={(event, uiData) => onStart(event, uiData)}
                      // >
                      <div className={'div-no-margin'} id={'drag-videonotes-' + videoNotes.id} ref={draggleRef}
                           onMouseDown={(event) => {
                               event.stopPropagation();
                               if (!getIsPin())return;
                               mIsDragging.current = true;
                               offset.current.x = event.clientX - draggleRef.current.getBoundingClientRect().left;
                               offset.current.y = event.clientY - draggleRef.current.getBoundingClientRect().top;
                               setPointerEvents('none');
                               // window.bringDialogVideoFront(videoNotes);
                           }} onMouseMove={(event) => {
                          if (mIsDragging.current) {
                              setX(event.clientX - offset.current.x);
                              setY(event.clientY - offset.current.y);
                          }
                      }} onMouseUp={(event) => {
                          mIsDragging.current = false;
                          setPointerEvents('all');
                      }} style={{}} onClick={(event) => {
                          event.stopPropagation();
                          window.bringDialogVideoFront(videoNotes);
                      }}>
                          {modal}
                          {/* 四个拖拽手柄 */}
                          {
                              isPin &&
                              <>
                                  <div className="resize-handle top-left" onMouseDown={handleMouseDown('top-left')}/>
                                  <div className="resize-handle top-right" onMouseDown={handleMouseDown('top-right')}/>
                                  <div className="resize-handle bottom-left" onMouseDown={handleMouseDown('bottom-left')}/>
                                  <div className="resize-handle bottom-right" onMouseDown={handleMouseDown('bottom-right')}/>
                                  <div className="resize-handle left" onMouseDown={handleMouseDown('left')}/>
                                  <div className="resize-handle right" onMouseDown={handleMouseDown('right')}/>
                                  <div className="resize-handle top" onMouseDown={handleMouseDown('top')}/>
                                  <div className="resize-handle bottom" onMouseDown={handleMouseDown('bottom')}/>
                              </>
                          }

                          {/* 你的内容 */}
                      </div>
                      // </Draggable>
                  )}
              >
                  {(isFileVideoElement(videoNotes.element) || isAudioFileElement(videoNotes.element)) && (
                      <VideoLocalContent videoNotes={videoNotes} isFullScreen={isFullScreen} dialogSize={{height: (dialogSize.height - 75),width:dialogSize.width}}
                                         ref={videoContentRef} from={isAudioFileElement(videoNotes.element) ? 'slider' : ''} subFrom={from}/>
                  )}
                  {isEmbeddableElement(videoNotes.element) && (
                      <VideoContent videoNotes={videoNotes} isFullScreen={isFullScreen} dialogSize={{height: (dialogSize.height - 75)}}
                                    ref={videoContentRef} subFrom={from}/>
                  )}
              </Modal>

          </ConfigProvider>
      </div>
    );
  },
);

export default (VideoNotes);
